<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('pickupHistory.pageTitle') }}</h1>
      <ts-breadcrumb :items="[
        { text: $t('toHomePage'), href: '/' },
        {
          text: $t('pickupHistory.pageTitle'),
          active: true
        }
      ]" />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-lg-6 com-md-9 col-sm-12 d-flex justify-content-start"></div>
          <div class="col-lg-6 com-md-3 col-sm-12 d-flex justify-content-end">
            <ts-input v-model="search" :placeholder="$t('search')" style="width: 300px" class="ml-2" />
            <ts-button outline class="ml-2" v-tooltip="$t('filter')" @click.prevent="visible = true">
              <i class="fa fa-filter"></i>
            </ts-button>
          </div>
        </div>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <ts-table :columns="columns" :records="resources" :loading="loading" :rowGroup="{
          field: 'picked_up_date_show'
        }">
          <template v-slot="{ record }">
            <td class="ts-whitespace-no-wrap">
              {{ record.branch.branch_name_en }}
            </td>
            <td class="with-img">
              <img class="height-30 ts-rounded" v-lazy="{
                src: studentPhoto(record),
                error: onErrorStudent(record),
                loading: require('@/assets/Rolling-1s-200px_2.svg')
              }" />
            </td>
            <td class="ts-whitespace-no-wrap text-center">
              {{ record.student_card_number }}
            </td>
            <td class="ts-whitespace-no-wrap">{{ record.student_name }}</td>
            <td class="ts-whitespace-no-wrap text-center">
              {{ record.picked_up_time_show }}
            </td>
            <td class="ts-whitespace-no-wrap text-center">
              {{ record.relationship }}
            </td>
            <td class="with-img">
              <img class="height-30 ts-rounded" v-lazy="{
                src: guardianPhoto(record),
                error: onError(record),
                loading: require('@/assets/Rolling-1s-200px_2.svg')
              }" />
            </td>
            <td class="ts-whitespace-no-wrap text-center">
              {{ record.card_number }}
            </td>
            <td class="ts-whitespace-no-wrap">{{ record.guardian }}</td>
            <td class="ts-whitespace-no-wrap text-center">
              {{ record.student_acknowledge_time_show }}
            </td>
            <td class="ts-whitespace-no-wrap">{{ record.loginname }}</td>
            <td class="ts-whitespace-no-wrap text-center">
              {{ record.display_counter }}
            </td>
            <td class="ts-whitespace-no-wrap text-center">
              <span class="ios-checkmark-circle-outline badge bg-success" v-if="record.is_priority">Yes</span>
              <span class="ios-close-circle-outline badge bg-danger" v-else>No</span>
            </td>
          </template>
        </ts-table>
      </div>
      <ts-card-wrapper>
        <div class="d-flex justify-content-between align-items-center">
          
          <ts-pagination v-model="pagination" @navigate="fetchData"></ts-pagination>
        </div>
      </ts-card-wrapper>
      <a-drawer :title="$t('filter')" placement="right" :closable="false" :visible="visible"
        @close="() => (visible = false)" :zIndex="1020" width="300px">
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <a-select style="width: 257px" v-model="branch_id" :options="branchs" showSearch mode="multiple"
                :filterOption="(input, option) =>
                    option.componentOptions.children[0].text
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  " :maxTagCount="1" :maxTagTextLength="17" :placeholder="$t('all')">
              </a-select>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <a-range-picker format="DD-MM-YYYY" :defaultValue="rangeDate" :defaultPickerValue="rangeDate"
                @change="dateRangeChange">
                <template slot="renderExtraFooter"></template>
              </a-range-picker>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <treeselect :load-options="loadStudent" :multiple="true" :limit="1" :options="studentOptions"
                :placeholder="$t('all')" v-model="student_id" />
            </div>
          </div>
        </div>
      </a-drawer>
    </ts-card>
  </div>
</template>

<script>
import { LOAD_ROOT_OPTIONS } from '@riophae/vue-treeselect'
import { Errors } from 'form-backend-validation'
import { mapState, mapActions } from 'vuex'
import { debounce } from 'lodash'
import moment from 'moment'

export default {
  name: 'pickupHistory',
  data() {
    return {
      rangeDate: [moment(), moment()],
      loading: false,
      branchs: [],
      student_id: [],
      visible: false,
      studentOptions: null,
      classOptions: null,
      errors: new Errors(),
      manPhoto: require('../../assets/staff-default-man.png'),
      womenPhoto: require('../../assets/staff-default-women.png'),
      defaultPhoto: require('../../assets/user_default.png'),
      boyPhoto: require('../../assets/student-default-boy.png'),
      girlPhoto: require('../../assets/student-default-girl.png')
    }
  },
  computed: {
    ...mapState('pickupHistory', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.pickupHistory.search
      },
      set(newVal) {
        this.$store.commit('pickupHistory/SET_SEARCH', newVal)
        this.$store.commit('pickupHistory/RESET_CURRENT_PAGE')
      }
    },
    branch_id: {
      get() {
        return this.$store.state.pickupHistory.branch_id
      },
      set(newValue) {
        this.$store.commit('pickupHistory/SET_BRANCH_ID', newValue)
      }
    },
    columns() {
      return [
        {
          name: this.$t('pickupHistory.branch'),
          sortKey: 'branch.branch_name_en'
        },
        {
          name: this.$t('pickupHistory.photo')
        },
        {
          name: this.$t('pickupHistory.cardNumber'),
          sortKey: 'student_card_number',
          style: 'text-align: center'
        },
        {
          name: this.$t('pickupHistory.studentName'),
          sortKey: 'student.student_name'
        },
        {
          name: this.$t('pickupHistory.pickupTime'),
          style: 'text-align: center'
        },
        {
          name: this.$t('pickupHistory.relationship'),
          sortKey: 'relationship',
          style: 'text-align: center'
        },
        {
          name: this.$t('pickupHistory.photo')
        },
        {
          name: this.$t('pickupHistory.cardNumber'),
          sortKey: 'card_number',
          style: 'text-align: center'
        },
        {
          name: this.$t('pickupHistory.guardianName'),
          sortKey: 'guardian'
        },
        {
          name: this.$t('pickupHistory.acknowledgeTime'),
          style: 'text-align: center'
        },
        {
          name: this.$t('pickupHistory.staffName')
        },
        {
          name: this.$t('pickupHistory.displayCounter'),
          style: 'text-align: center'
        },
        {
          name: this.$t('pickupHistory.isPriority'),
          sortKey: 'is_priority',
          style: 'text-align: center'
        }
      ]
    }
  },
  created() {
    this.branch_id = [this.$store.state.authUser.default_branch_id]
    this.fetchData()
    this.getBranch()
  },
  methods: {
    ...mapActions('pickupHistory', ['fetchStudents']),
    async loadStudent({ action /*, callback*/ }) {
      if (action === LOAD_ROOT_OPTIONS) {
        this.studentOptions = null
        await this.fetchStudents()
          .then(response => {
            this.studentOptions = response.data.map(el => ({
              id: el.student_id,
              label: el.full_name_en + '|' + el.full_name_kh
            }))
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
      }
    },
    fetchData(attributes) {
      this.loading = true
      this.errors = new Errors()
      this.$store
        .dispatch(
          'pickupHistory/fetch',
          Object.assign(
            {},
            { branch_id: this.branch_id },
            { student_id: this.student_id },
            attributes
          )
        )
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
    },
    getBranch() {
      this.$store
        .dispatch('user/getBranch', {
          filter: {
            user_branches: true
          }
        })
        .then(response => {
          this.branchs = response.data.map(el => ({
            value: el.branch_id,
            label: el.branch_name_en
          }))
        })
    },
    guardianPhoto(record) {
      if (record.pickup.photo) {
        return record.pickup.photo
      }
      if (record.relationship == 'Father') {
        return this.manPhoto
      }
      if (record.relationship == 'Mother') {
        return this.womenPhoto
      }
      if (record.relationship == 'Other') {
        return this.defaultPhoto
      }
    },
    onError(record) {
      event
        ? (event.target.src =
          record.relationship == 'Father' ? this.manPhoto : this.womenPhoto)
        : ''
    },

    studentPhoto(record) {
      if (record.student.photo) {
        return record.student.photo
      }

      return record.student.gender == 'Male' ? this.boyPhoto : this.girlPhoto
    },
    onErrorStudent(record) {
      event
        ? (event.target.src =
          record.student.gender == 'Male' ? this.boyPhoto : this.girlPhoto)
        : ''
    },
    dateRangeChange(dateRange) {
      this.$store.commit(
        'pickupHistory/SET_DATE_FROM',
        dateRange[0].format('DD-MM-YYYY')
      )
      this.$store.commit(
        'pickupHistory/SET_DATE_TO',
        dateRange[1].format('DD-MM-YYYY')
      )
      this.fetchData()
    }
  },
  watch: {
    'model.class_id': function (value) {
      this.model.student_id = []
      this.studentOptions = null
      if (value) {
        this.fetchStudents({ class_id: value })
      }
    },
    search: debounce(function (search) {
      this.fetchData({
        search,
        branch_id: this.branch_id,
        student_id: this.student_id
      })
    }, 500),
    branch_id: debounce(function (value) {
      this.fetchData({ branch_id: value, student_id: this.student_id })
    }, 500),
    student_id: debounce(function (value) {
      this.fetchData({ student_id: value, branch_id: this.branch_id })
    }, 500)
  }
}
</script>
